import React, { useEffect, useState } from 'react';

/**
 * Shows an "Install app" button when the browser signals the PWA can be
 * installed (Android/Chrome/Edge). Hidden once installed or when unsupported
 * (e.g. iOS, where users install via Share → Add to Home Screen).
 */
export default function InstallButton() {
  const [promptEvent, setPromptEvent] = useState(null);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPromptEvent(e); };
    const onInstalled = () => setPromptEvent(null);
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  if (!promptEvent) return null;

  const install = async () => {
    promptEvent.prompt();
    try { await promptEvent.userChoice; } catch { /* ignore */ }
    setPromptEvent(null);
  };

  return (
    <button className="btn btn-sm btn-primary install-btn" onClick={install} title="Install the app">
      ⬇ Install App
    </button>
  );
}
